import {
  Companion_getInstance3bisd6gjnm0oz as Companion_getInstance,
  ApprovedState3hrsq7yllchx0 as ApprovedState,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { State3dw676r1r3e8w as State } from './enums.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_approved(_this__u8e3s4) {
  return _this__u8e3s4.prop(ApprovedState_approved_getInstance());
}
function prepareApprovedStateFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [ApprovedState__id_getInstance(), ApprovedState_approved_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function ApprovedState_approved$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function ApprovedState_approved$_get_name_$ref_ikjiaf() {
  return (p0) => p0.k20();
}
function ApprovedState_approved$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ApprovedState_approved$_get_serializer_$ref_5dgikw() {
  return (p0) => p0.j2j();
}
function ApprovedState_approved$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function ApprovedState_approved$_get_annotations_$ref_uef3f8() {
  return (p0) => p0.bz();
}
var ApprovedState_approvedClass;
function ApprovedState_approved() {
  if (ApprovedState_approvedClass === VOID) {
    class $ {
      constructor() {
        ApprovedState_approved_instance = this;
        var tmp = this;
        tmp.v56_1 = lazy(ApprovedState_approved$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.w56_1 = lazy(ApprovedState_approved$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.x56_1 = lazy(ApprovedState_approved$annotations$delegate$lambda);
        this.y56_1 = false;
        this.z56_1 = 'false';
      }
      k20() {
        var tmp0 = this.v56_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ApprovedState_approved$_get_name_$ref_ikjiaf(), null);
        return tmp0.f2();
      }
      a57(receiver) {
        return receiver.c57_1;
      }
      m2j(receiver) {
        return this.a57(receiver instanceof ApprovedState() ? receiver : THROW_CCE());
      }
      d57(receiver, value) {
        return receiver.e57(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ApprovedState() ? receiver : THROW_CCE();
        return this.d57(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.w56_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ApprovedState_approved$_get_serializer_$ref_5dgikw(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.x56_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ApprovedState_approved$_get_annotations_$ref_uef3f8(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ApprovedState_approved', VOID, VOID, [SerializableProperty()]);
    ApprovedState_approvedClass = $;
  }
  return ApprovedState_approvedClass;
}
var ApprovedState_approved_instance;
function ApprovedState_approved_getInstance() {
  if (ApprovedState_approved_instance === VOID)
    new (ApprovedState_approved())();
  return ApprovedState_approved_instance;
}
function ApprovedState__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function ApprovedState__id$_get_name_$ref_ir3syq() {
  return (p0) => p0.k20();
}
function ApprovedState__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ApprovedState__id$_get_serializer_$ref_oexcll() {
  return (p0) => p0.j2j();
}
function ApprovedState__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function ApprovedState__id$_get_annotations_$ref_8dtoml() {
  return (p0) => p0.bz();
}
var ApprovedState__idClass;
function ApprovedState__id() {
  if (ApprovedState__idClass === VOID) {
    class $ {
      constructor() {
        ApprovedState__id_instance = this;
        var tmp = this;
        tmp.f57_1 = lazy(ApprovedState__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g57_1 = lazy(ApprovedState__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h57_1 = lazy(ApprovedState__id$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.f57_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ApprovedState__id$_get_name_$ref_ir3syq(), null);
        return tmp0.f2();
      }
      a57(receiver) {
        return receiver.b57_1;
      }
      m2j(receiver) {
        return this.a57(receiver instanceof ApprovedState() ? receiver : THROW_CCE());
      }
      i57(receiver, value) {
        return receiver.e57(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ApprovedState() ? receiver : THROW_CCE();
        return this.i57(tmp, value instanceof State() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.g57_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ApprovedState__id$_get_serializer_$ref_oexcll(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h57_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ApprovedState__id$_get_annotations_$ref_8dtoml(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ApprovedState__id', VOID, VOID, [SerializableProperty()]);
    ApprovedState__idClass = $;
  }
  return ApprovedState__idClass;
}
var ApprovedState__id_instance;
function ApprovedState__id_getInstance() {
  if (ApprovedState__id_instance === VOID)
    new (ApprovedState__id())();
  return ApprovedState__id_instance;
}
//region block: exports
export {
  get_approved as get_approvedfugbsw3v6f3w,
  prepareApprovedStateFields as prepareApprovedStateFields2xaeuenjwqlt5,
};
//endregion

//# sourceMappingURL=ApprovedStateFields.mjs.map
